import { Auth0Client } from '@auth0/auth0-spa-js'
import { clearLocalStorage } from '../localstorage'
import { getDefaultAudience } from '@paintscout/util/src/users/getDefaultAudience/getDefaultAudience'

export const audience = `https://api.${getDefaultAudience()}`

export const scope = `openid email profile https://${getDefaultAudience()}/user_metadata https://${getDefaultAudience()}/app_metadata offline_access`

export async function clearUserData(companyId: string) {
  clearLocalStorage({
    whitelist: [
      'calendarView',
      'blockLaunchDialog',
      'boardViewSort',
      'dealTableColumns',
      'dashboardOptions',
      `dashboardOptions-${companyId}`,
      'quoteOptions.sidebarOpen',
      'sideNavExpanded',
      'quoteTableColumns',
      'taskTableColumns'
    ],
    whiteListPartialMatch: ['reportState/']
  })
}

export const auth = new Auth0Client({
  domain: process.env.AUTH0_DOMAIN as string,
  clientId: process.env.AUTH0_APP_CLIENT_ID as string,
  authorizationParams: {
    redirect_uri: `${process.env.PS_APP_URL}/login-callback`,
    audience,
    scope
  },
  authorizeTimeoutInSeconds: 60,
  useRefreshTokens: true,
  cacheLocation: 'localstorage',
  useRefreshTokensFallback: true
})
